import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";

const SOCIAL_LINKS = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/zainematics",
    icon: FaFacebookF,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/zainematics/",
    icon: FaInstagram,
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@zainematics",
    icon: FaYoutube,
  },
];

function MainContact() {
  return (
    <section className="student-section student-contact" aria-label="Contact">
      <div className="student-section__inner student-contact__layout">
        <div className="student-contact__info">
          <p className="student-section__eyebrow">Get in touch</p>
          <h2 className="student-section__title">Contact us</h2>
          <p className="student-contact__intro">
            Have questions or want to get in touch? Reach out to us at:
          </p>
          <ul className="student-contact__list">
            <li className="student-contact__item">
              <span className="student-contact__label">Address</span>
              <p className="student-contact__value">
                216, Street 10, Commercial Area Y block, Phase 3, DHA Lahore
              </p>
            </li>
            <li className="student-contact__item">
              <span className="student-contact__label">Phone</span>
              <p className="student-contact__value">
                <a href="tel:+923260010161">+92 326 0010161</a>
              </p>
            </li>
            <li className="student-contact__item">
              <span className="student-contact__label">Email</span>
              <p className="student-contact__value">
                <a href="mailto:contact@zainematics.com">
                  contact@zainematics.com
                </a>
              </p>
            </li>
            <li className="student-contact__item">
              <span className="student-contact__label">Social</span>
              <div className="student-contact__socials">
                {SOCIAL_LINKS.map(({ name, href, icon: Icon }) => (
                  <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="student-contact__social"
                    aria-label={`${name} (opens in a new tab)`}
                  >
                    <Icon aria-hidden="true" />
                    <span>{name}</span>
                  </a>
                ))}
              </div>
            </li>
          </ul>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3402.8804753682737!2d74.37348177369431!3d31.472473949508576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190757bb52a449%3A0x47bb29e7efd80b4b!2sZAINEMATICS!5e0!3m2!1sen!2s!4v1735588209542!5m2!1sen!2s"
          className="student-contact__map"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="location"
        />
      </div>
    </section>
  );
}

export default MainContact;
